'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_783e1af8 = {"container":"ExpandCell_module_container__20e3a3d1","icon":"ExpandCell_module_icon__20e3a3d1"};
require("../../../assets/cjs/components/Table/src/ExpandColumn~0IdIQ5u2.css");

exports.default = modules_783e1af8;
//# sourceMappingURL=ExpandCell.module.less.js.map
